import { ELandingType } from '../../types/landingType';

export function getNextStep<TStep>(
  steps: TStep[],
  fallBackStep: TStep,
  landingType?: ELandingType,
  activeStep?: TStep,
): TStep {
  if (!landingType || !activeStep || activeStep === fallBackStep) {
    return steps[0] || fallBackStep;
  }

  return steps[steps.findIndex(step => step === activeStep) + 1] || fallBackStep;
}
